import useCountryList from "src/hooks/address/useCountryList";
import useProvinceList from "src/hooks/address/useProvinceList";
import useDistrictList from "src/hooks/address/useDistrictList";
import useWardList from "src/hooks/address/useWardList";

export const useAddressData = (province, district, addressLevel) => {
  const { data: countries } = useCountryList({
    limit: 500,
    skip: 0,
    sortField: "name",
    sortOrder: "asc",
  });

  const { data: provinces } = useProvinceList({
    limit: 200,
    skip: 0,
    version: addressLevel === 2 ? 2 : undefined,
    sortField: "name",
    sortOrder: "asc",
  });

  const { data: districts } = useDistrictList(
    !!province &&
      addressLevel === 3 && {
        limit: 200,
        skip: 0,
        province: !!province ? province?.id : 1,
        sortField: "name",
        sortOrder: "asc",
      },
  );

  const { data: wards } = useWardList(
    !!province &&
      (!!district || addressLevel === 2) && {
        limit: 200,
        skip: 0,
        province: !!province && addressLevel === 2 ? province?.id : undefined,
        district: addressLevel === 3 && !!district ? district?.id : undefined,
        sortField: "name",
        sortOrder: "asc",
        version: addressLevel === 2 ? 2 : undefined,
      },
  );

  return {
    countries,
    provinces,
    districts,
    wards,
  };
};
